import classNames from 'classnames';
import * as React from 'react';

import { DataAttributes } from '../../common';
import css from './MenuSection.css';

export interface MenuSectionProps extends DataAttributes {
  id: string;
  children?: React.ReactNode;
  className?: string;
  name?: string;
  hide?: boolean;
  sectionId?: string;
  scrollAreaClassName?: string;
}

// Note: DataAttributes are intentionally not applied to the DOM here.
// They are passed as props so that StickyMenu can extract and forward them to menu component items, e.g. for click tracking.
export default function MenuSection({ children, className, hide, id, scrollAreaClassName }: MenuSectionProps) {
  return (
    !hide && (
      <section className={classNames(css.MenuSection, className)}>
        <span id={id} className={classNames(scrollAreaClassName, css.scrollArea)} />
        {children}
      </section>
    )
  );
}
